export default __webpack_public_path__ + "static/media/Dyl.339e2d51.png";